module.exports = __webpack_public_path__ + "static/img/beta_bg_14.367bcd55.svg";